module.exports = __webpack_public_path__ + "img/cm.b2723805.svg";